import styled from "@emotion/styled";

export const Wrapper = styled.div`
  display: flex;
  position: relative;
`

export const Edit = styled.button`
  margin-right: 12px;
  justify-content: center;
  display: flex;
  border: none;
  background: transparent;
  margin-top: 3px;
`

export const InnerWrapper = styled.div`
position: absolute;
display: flex;
flex-direction: row;
top:-5px;
`